var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2857 0C15.2143 0 16 0.785714 16 1.71429V14.2857C16 15.25 15.2143 16 14.2857 16H9.35714V10.5714H11.4286L11.8214 8H9.35714V6.35714C9.35714 5.64286 9.71429 4.96429 10.8214 4.96429H11.9286V2.78571C11.9286 2.78571 10.9286 2.60714 9.92857 2.60714C7.92857 2.60714 6.60714 3.85714 6.60714 6.07143V8H4.35714V10.5714H6.60714V16H1.71429C0.75 16 0 15.25 0 14.2857V1.71429C0 0.785714 0.75 0 1.71429 0H14.2857Z",
    fill: "#4267B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.4cc9c43e2da2a2044f3734a555212889.svg";
export { ForwardRef as ReactComponent };